import useFullyFledgedField from '@gef-ui/form-core/hooks/field/useFullyFledgedField';
import useContextOrStorage from '@gef-ui/form-core/hooks/stream/useContextOrStorage';
import DropzoneComponent from '@gef-ui/material/components/Dropzone';
import chainHandlers from "@gef-ui/utils/chainHandlers";
import invariant from 'invariant';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { resolveHiddenProp, useFieldDefaultValue } from '../utils';
export const COMPONENT_NAME = 'Dropzone';
const useValidationArgs = (fieldName, validationName, argument, required)=>{
    const fieldDescriptor = useContextOrStorage().formDescriptor[fieldName];
    return useMemo(()=>{
        const validation = fieldDescriptor?.validations?.find(({ name })=>name === validationName);
        if (required) {
            invariant(!!validation, `Please specify ${validationName}  validation for Dropzone`);
        }
        return validation?.[argument];
    }, [
        fieldDescriptor,
        validationName,
        argument,
        required
    ]);
};
const Dropzone = (inProps)=>{
    const props = useFieldDefaultValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { fieldName, fieldIndices, initiallyDirty, onChange, disabled: disabledByProp, ...other } = props;
    const { value, errorMessage, errMeta, handleChange, validateField, fieldId, disabled, asyncValidationInProgress, hidden } = useFullyFledgedField({
        fieldName,
        fieldIndices,
        initiallyDirty,
        disabled: disabledByProp
    });
    const acceptSize = useValidationArgs(fieldName, 'MAX_FILE_SIZE', 'maxSize', true);
    const totalAcceptSize = useValidationArgs(fieldName, 'TOTAL_MAX_FILE_SIZE', 'maxSize', true);
    const acceptExtensions = useValidationArgs(fieldName, 'ACCEPT_FILE_EXTENSIONS', 'extension', true);
    const numOfFiles = useValidationArgs(fieldName, 'MAX_NUM_OF_FILES', 'numOfFiles', false);
    const passFilesToState = useCallback((e, files)=>{
        handleChange(e, files.map(({ file, ...other })=>other));
    }, [
        handleChange
    ]);
    return /*#__PURE__*/ React.createElement(DropzoneComponent, {
        acceptSize: acceptSize,
        totalAcceptSize: totalAcceptSize,
        acceptExtensions: acceptExtensions,
        id: fieldId,
        disabled: disabled,
        validationText: errorMessage,
        asyncValidationInProgress: asyncValidationInProgress,
        value: value || [],
        handleFileChange: chainHandlers([
            passFilesToState,
            validateField,
            onChange
        ]),
        errMeta: errMeta,
        showSize: !!totalAcceptSize,
        numOfFiles: numOfFiles,
        ...other,
        ...resolveHiddenProp(hidden, other)
    });
};
Dropzone.propTypes = {
    disabled: PropTypes.bool,
    fieldIndices: PropTypes.arrayOf(PropTypes.number),
    fieldName: PropTypes.string,
    initiallyDirty: PropTypes.bool,
    modelParser: PropTypes.func,
    onChange: PropTypes.func,
    viewParser: PropTypes.func
};
export default Dropzone;
